import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observe, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Col, Form, FormGroup, Label, Row } from 'reactstrap';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { IInventoryTotal, ITest } from '../../../../../Interfaces/TestInterface';
import EInput from '../../../../EInput';
import './TotalHeader.scss';

@inject('stores')
@observer
class TotalHeader extends React.Component {
    public props: any;
    private test: ITest = new ITest();
    public TestsStore: any;
    private TenantStore: TenantStore;
    private testDisposer: any;
    private inventoryTotal: IInventoryTotal = new IInventoryTotal();

    public state = {
        inventoryTotal: this.inventoryTotal,
        isDirty: false,
        test: this.test
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    public componentWillMount() {
        this.setState({
            test: toJS(this.props.test)
        });
        
        this.createDisposers();
    }

    public componentWillReceiveProps(nextProps: any) {
            const test = nextProps.test;
            this.reCalc(test);
            this.setState({
                test: toJS(nextProps.test)
            });
    }

    public createDisposers() {
        this.testDisposer = observe(this.TestsStore, 'test', (change: any) => {
            const test = toJS(change.newValue);
            this.reCalc(test);
            this.setState({
                test
            });
        });

    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public clearDisposers() {
        if ( this.testDisposer ) {
            this.testDisposer();
        }
    }

    private handleInputChange(event: any) {
        const test = this.state.test;
        test.inventoryTotal[event.target.name] = event.target.value;
        this.reCalc(test);
        this.setState({
            isDirty: true,
            test
        });
        this.props.handleChange(test);
    }

    private reCalc(test: ITest) {
        // const test = toJS(this.state.test);
        
        this.TestsStore.calculateTotalCosts(test);
    }

    public render() {
        return(
            <Form className="TotalHeader">
                <Row>
                    <Col md="2">
                        <Label>Product Total</Label>
                    </Col>
                    <Col md="2">
                        <Label>Product Tax</Label>
                    </Col>
                    <Col md="2">
                        <Label>EBP Costs</Label>
                    </Col>
                    <Col md="3">
                        <Label>EBP Costs Tax</Label>
                    </Col>
                    <Col md="3">
                        <Label>Total</Label>
                    </Col>
                    <Col md="2">
                        <EInput
                            disabled={true}
                            type="text"
                            name="productTotal"
                            id="productTotal"
                            data-mask="currency"
                            value={this.state.test.inventoryTotal.productTotal}
                        />
                    </Col>
                    <Col md="2">
                        <EInput
                            disabled={true}
                            type="text"
                            name="productTax"
                            id="productTax"
                            data-mask="currency"
                            value={this.state.test.inventoryTotal.productTax}
                        />
                    </Col>
                    <Col md="2">
                        <EInput
                            disabled={true}
                            type="text"
                            name="otherCosts"
                            id="otherCosts"
                            data-mask="currency"
                            value={this.state.test.inventoryTotal.otherCosts}
                        />
                    </Col>
                    <Col md="2">
                        <EInput
                            disabled={true}
                            type="text"
                            name="otherCostTax"
                            id="otherCostTax"
                            data-mask="currency"
                            value={this.state.test.inventoryTotal.otherCostTax}
                        />
                    </Col>
                    <Col md="1" className="align-center">
                        <FontAwesomeIcon icon="equals" color={this.TenantStore.iconColor} />
                    </Col>
                    <Col md="3">
                        <EInput
                            disabled={true}
                            type="text"
                            name="dailyTotal"
                            id="dailyTotal"
                            data-mask="currency"
                            value={this.state.test.inventoryTotal.dailyTotal}
                        />
                    </Col>
                    <Col md="12">
                        <hr/>
                    </Col>
                    <Col md="3">
                        <Label>State: {this.props.well.state}</Label><br/>
                        <Label>County: {this.props.well.countyParish}</Label>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Product Tax Rate (%)</Label>
                            <EInput
                                type="text"
                                name="productTaxRate"
                                id="productTaxRate"
                                value={this.state.test.inventoryTotal.productTaxRate}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Service Tax Rate (%)</Label>
                            <EInput
                                type="text"
                                name="serviceTaxRate"
                                id="serviceTaxRate"
                                value={this.state.test.inventoryTotal.serviceTaxRate}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Rental Tax Rate (%)</Label>
                            <EInput
                                type="text"
                                name="rentalTaxRate"
                                id="rentalTaxRate"
                                value={this.state.test.inventoryTotal.rentalTaxRate}
                                disabled={true}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={{size: 3}}>
                        <FormGroup>
                            <Label>Cumulative</Label>
                            <EInput
                                disabled={true}
                                type="text"
                                name="cumulativeTotal"
                                id="cumulativeTotal"
                                data-mask="currency"
                                value={this.state.test.inventoryTotal.cumulativeTotal}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default TotalHeader;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/Inventory/TotalHeader/TotalHeader.tsx